import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { RootState } from 'redux/store';
import { getStores } from 'redux/slices/Stores';
import { getOwners } from 'redux/slices/Owners';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import { getStoreGroups } from 'redux/slices/Accounts';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { Table, Title, SnackBarMessage, SnackBarMessageProps } from 'components';
import { getOwnerNameById } from 'helpers/data/dataHandling';

export function Stores() {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const stores = useAppSelector((state: RootState) => state.stores);
	const owners = useAppSelector((state: RootState) => state.owners);
	const [snackSettings, setSnackSettings] = React.useState<SnackBarMessageProps>(new SnackBarMessageProps());
	const currentStoreGroupId = useAppSelector((state: RootState) => state.global.storeGroupId);

	useEffect(() => {
		dispatch(getOwners());
		dispatch(getStores({ }));
		dispatch(getStoreGroups());
	}, []);

	const columnsb = [
		{
			Header: 'Name',
			accessor: 'name',
			width: 300,
			defaultCanSort: true,
			Cell: (row: any) => <Link to={`/support/store/${row.cell.row.original.id}`}>{row.value}</Link>,
		},
		{
			Header: 'Owner Name',
			accessor: 'ownerId',
			width: 200,
			defaultCanSort: true,
			Cell: (row: any) => <>{getOwnerNameById(row.value, owners.table)}</>,
		},
		{
			Header: 'Status',
			accessor: 'connected',
			width: 200,
			defaultCanSort: true,
			Cell: (row: any) => {
				return (
					<>
						{row.cell.row.original.connected === false && <Badge className="me-1 badge-outline-danger">Offline</Badge>}
						{row.cell.row.original.connected === true && <Badge className="me-1 badge-outline-primary">Online</Badge>}
					</>
				);
			}
		},
		{
			Header: 'Username',
			accessor: 'username',
			width: 600,
			defaultCanSort: true,
		},
		{
			Header: 'Running Version',
			accessor: 'lastRunningVersion',
			width: 600,
			defaultCanSort: true,
		},
	];

	return (
		<>
			<Title pageTitle="Stores" parent="Support" />
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className="mb-1">
								<div className="page-container">
									<Table
										columns={columnsb}
										data={stores.table}
										pageSize={15}
										isSortable={true}
										pagination={true}
										isSelectable={true}
										isSearchable={true}
										reloadTableRows={() => dispatch(getStores({ limit: 10000 }))}
										addNewRow={() => navigate("/support/store/new")}
									/>
									<SnackBarMessage {...snackSettings} />
								</div>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	);
}